import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { staticAPI } from '../api';
import { CLIENT_NOTS, getClientNotify } from './notifySlice';
import imageNotFound from '../assets/image-not-found.jpg';
import { dropUserDocument } from './userSlice';
import { dropOrderImage } from './orderSlice';
import { dropPromoterDocument } from './advertSlice';


const initialState = {
    photos: [],
    videos: [],
};

export const getImage = createAsyncThunk(
    'image/fetchImage',
    async ({ type, name }, thunkAPI) => {
        const isImageLoaded = (thunkAPI.getState()).static.photos.find(
            (img) => img.type === type && img.name === name,
        );
        if (!isImageLoaded) {
            const response = await staticAPI.getImage(type, name);
            let src = imageNotFound;
            if (response.status === 200) {
               
                const photoURL = URL.createObjectURL(response.data);
                src = photoURL;
            } else {
                thunkAPI.dispatch(
                    getClientNotify({ data: response, action: CLIENT_NOTS.IMAGE_ERROR }),
                );
            }
            thunkAPI.dispatch(pushImage({ type, name, src }));
            return;
        }
    },
);

export const getRouteVideo = createAsyncThunk(
    'image/fetchRouteVideo',
    async ({ type, name, promoterId, routeId }, thunkAPI) => {
        const hasVideo = (thunkAPI.getState()).static.videos.some(
            (video) => video.name === name,
        );
        if (hasVideo) return;
        try {
            const response = await staticAPI.getRouteContent(name, type, promoterId, routeId);//@ts-ignore
            let src = null;
            if (response.ok && response.status === 206) {//@ts-ignore
                const blob = await response.blob();
                src = URL.createObjectURL(blob);
            } else {
                thunkAPI.dispatch(
                    getClientNotify({ data: response, action: CLIENT_NOTS.VIDEO_ERROR }),
                );
            }

            thunkAPI.dispatch(pushVideo({ name, type, src }));
            return;
        } catch (e) {
            console.log(e);
        }
    },
);
export const getRoutePhoto = createAsyncThunk(
    'image/fetchRoutePhoto',
    async ({ type, name, promoterId, routeId }, thunkAPI) => {
        const hasPhoto = (thunkAPI.getState()).static.photos.some(
            (photo) => photo.name === name,
        );
        if (hasPhoto) return;
        try {
            const response = await staticAPI.getRouteContent(name, type, promoterId, routeId);
            let src = imageNotFound;
            if (response.status === 200) {
               
                const blob = await response.blob();
                src = URL.createObjectURL(blob);
            } else {
                thunkAPI.dispatch(
                    getClientNotify({ data: response, action: CLIENT_NOTS.IMAGE_ERROR }),
                );
            }
            thunkAPI.dispatch(pushImage({ type, name, src }));
            return;
        } catch (e) {
            console.log(e);
        }
    },
);
export const deleteImage = createAsyncThunk(
    'image/delete',
    async ({ type, name }, thunkAPI) => {
        const data = await staticAPI.deleteImage(type, name);
        thunkAPI.dispatch(getClientNotify({ data, action: CLIENT_NOTS.DELETE_IMAGE }));
        if (data.isOkay) {
            thunkAPI.dispatch(dropImage({ fileName: data.fileName, type: data.type }));
            if (data.userId) {
                //Удаление документа пользователя
                thunkAPI.dispatch(
                    dropUserDocument({ userId: data.userId, fileName: data.fileName }),
                );
            } else if (data.orderId) {
                thunkAPI.dispatch(
                    dropOrderImage({ orderId: data.orderId, fileName: data.fileName }),
                );
            } else {
                thunkAPI.dispatch(
                    dropPromoterDocument({ promoterId: data.promoterId, fileName: data.fileName }),
                );
            }
        } else {
            console.log(data);
        }
    },
);

const staticSlice = createSlice({
    name: 'static',
    initialState,
    reducers: {
        pushImage(state, { payload }) {
            state.photos = [...state.photos, payload];
        },
        updateVideoUrl(state, { payload }) {
            console.log('update video', payload.src);
            state.videos = state.videos.map((v) =>
                v.name === payload.name && v.type === payload.type ? payload : v,
            );
        },
        setVideoLoaded(state, { payload }) {
            state.videos = state.videos.map((v) =>
                v.name === payload.name && v.type === payload.type ? { ...v, loaded: true } : v,
            );
        },
        pushVideo(state, { payload }) {
            state.videos = [...state.videos, payload];
        },
        dropImage(state, { payload }) {
            state.photos = state.photos.filter(
                (img) => img.type !== payload.type || img.name !== payload.fileName,
            );
        },
    },
    extraReducers: (builder) => {},
});

export const { setVideoLoaded, updateVideoUrl, pushImage, pushVideo, dropImage } =
    staticSlice.actions;

export default staticSlice.reducer;
